import { Field, Formik } from "formik"
import { Form, Modal } from "react-bootstrap"
import { InfoCard2 } from "../../../widgets/components/UI/InfoCard2"
import { useIntl } from "react-intl"
import TextInput from "../../../widgets/components/Input/TextInput"
import TextArea from "../../../widgets/components/Input/TextArea"
import { ToolTipUIForModal } from "../../../widgets/components/UI/ToolTipUIForModal"
import { useEffect, useState } from "react"
import deleteIcon from '../../../../../media/stakeholders/ic-delete.svg'
import * as Yup from 'yup'
import { FileUpload } from "../../../widgets/components/FileUpload"
import { getFileType } from "../../core/_util"
import { MinutesToAssigned } from "../../core/_constants"
import { createAgenda, updateAgenda } from "../../core/_requests"
import { toast } from "react-toastify"
import { DeleteFileConfirmationModal } from "../CancelConfimrationModal"
import { allowedFileTypes } from "../../../../core/_constants"
import TagManager from "react-gtm-module"
import { GTMEvent } from "../../../../hooks/gtmHelpers"
import { useAuth } from "../../../auth"
import TagInput from "../../../widgets/components/Input/TagInput"
import brandingConfig from "../../../../../config/brandingConfig"
export default function AddAgenda({ isActive, setIsActive, meetingId, editData, meetingType, leftTime, userList }: any) {
    const [loading, setLoading] = useState(false)
    const { companyId, currentUser } = useAuth()
    const { formatMessage } = useIntl()
    const [modelStatus, setModelStatus] = useState<boolean>(false)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [cancelLoading, setCancelLoading] = useState(false)
    const [id, setId] = useState('')
    const userSchema = Yup.object().shape({
        AgendaTitle: Yup.string().required('Agenda title is required'),
        Description: Yup.string(),
        Link: Yup.string().url('Invalid Url'),
        MinuteAssigned: Yup.string().required('Minutes of assigned required')

    })
    const initialValues = {
        AgendaTitle: editData ? editData.agendaTitle : '',
        Presenter: editData ? editData?.presenter.split(',').map((data: string) => ({
            label: data,
            value: data,
        })) : '',
        Description: editData ? editData?.description : '',
        Link: editData ? editData?.link : '',
        MinuteAssigned: editData ? editData?.assignedTime : '',
        fileIds: []
    }
    const handleSubmit = async (values: any) => {
        const payload = {
            agendaTitle: values.AgendaTitle,
            presenter: values.Presenter ? values.Presenter.map((option: { label: string; value: string }) => option.label).join(', ')
                : null,
            description: values.Description,
            link: values.Link,
            assignedTime: values.MinuteAssigned,
            fileIds: files.map((file: any) => { return file.id })
        }
        try {
            setLoading(true)
            const {
                data: { success, error },
            } = await createAgenda(payload, meetingId)
            if (success) {
                setLoading(false)
                toast.success(formatMessage({ id: 'Meeting agenda added successfully' }))
                setIsActive(false)
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.AgendaCreatedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            agenda_details: payload,
                        },
                    },
                })
            }
            else {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.AgendaCreateFailed,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            agenda_details: payload,
                            error: error[0]
                        },
                    },
                })
            }
        } catch (e) {
            console.log(e)
            TagManager.dataLayer({
                dataLayer: {
                    event: GTMEvent.AgendaCreateFailed,
                    action: 'normal',
                    metadata: {
                        company_id: companyId,
                        user_id: currentUser?.userId,
                        email: currentUser?.email,
                        agenda_details: payload,
                        error: e
                    },
                },
            })
        }
    }
    const handleUpdateSubmit = async (formik: any) => {
        const dirtyFields = Object.keys(formik.values).filter(
            key => formik.values[key] !== formik.initialValues[key]
        );
        const payload = dirtyFields.reduce((acc: any, key: any) => {
            acc[key] = formik.values[key];
            return acc;
        }, {});
        payload.fileIds = files.map((file: any) => { return file.id })
        console.log(payload);

        try {
            setLoading(true)
            const {
                data: { success, error },
            } = await updateAgenda(payload, meetingId, editData.agendaId)
            if (success) {
                setLoading(false)
                toast.success(formatMessage({ id: 'Agenda updated successfully' }))
                setIsActive(false)
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.AgendaUpdatedSuccessful,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            agenda_details: payload,

                        },
                    },
                })
            }
            else {
                TagManager.dataLayer({
                    dataLayer: {
                        event: GTMEvent.AgendaUpdateFailed,
                        action: 'normal',
                        metadata: {
                            company_id: companyId,
                            user_id: currentUser?.userId,
                            email: currentUser?.email,
                            agenda_details: payload,
                            error: error[0]
                        },
                    },
                })
            }
        } catch (e) {
            TagManager.dataLayer({
                dataLayer: {
                    event: GTMEvent.AgendaUpdateFailed,
                    action: 'normal',
                    metadata: {
                        company_id: companyId,
                        user_id: currentUser?.userId,
                        email: currentUser?.email,
                        agenda_details: payload,
                        error: e
                    },
                },
            })
        } finally { setLoading(false) }
    }
    const [files, setFiles] = useState<any[]>([])
    const handleClose = () => {
        setModelStatus(false)
    }
    const handleOpen = () => {
        setModelStatus(true)
    }
    const deleteFile = () => {
        setCancelLoading(true)
        setFiles(files.filter((file: any) => file.id !== id))
        setCancelLoading(false)
        setShowCancelModal(false)
        toast.success(formatMessage({ id: 'File removed successfully' }))
        TagManager.dataLayer({
            dataLayer: {
                event: GTMEvent.FileRemovedSuccessful,
                action: 'normal',
                metadata: {
                    company_id: companyId,
                    user_id: currentUser?.userId,
                    email: currentUser?.email,
                    fileId: id
                },
            },
        })
    }
    useEffect(() => {
        if (editData) {
            const fileData = editData.AgendaDocuments.map((file: any) => {
                return { id: file.file.fileId, name: file.file.fileName }
            })
            setFiles(fileData)
        }

    }, [])// eslint-disable-line react-hooks/exhaustive-deps    


    return <>
        <Modal
            show={isActive}
            onHide={() => {
                setIsActive(false)
            }}
            fullscreen
        >
            <Modal.Header closeButton>
                <div className="d-flex flex-column">
                    <h2>{editData ? formatMessage({ id: 'Edit Agenda' }) : formatMessage({ id: 'Add Agenda' })}</h2>
                </div>
            </Modal.Header>
            <Formik
                initialValues={initialValues}
                validationSchema={userSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                validateOnMount
            >
                {(formik) => {
                    return (
                        <>
                            <Modal.Body className="h-100 container">
                                {meetingType === 'Virtual Meeting' ?
                                    <InfoCard2 title={formatMessage({ id: "How to Schedule Virtual Compliance Meetings?" })} desc={formatMessage({ id: `Schedule virtual compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding scheduling details, managing participants, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.` })} slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingVirtual} /> :
                                    <InfoCard2 title={formatMessage({ id: "How to Schedule Physical Compliance Meetings?" })} desc={formatMessage({ id: `Schedule physical compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding venue and scheduling details, inviting attendees, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.` })} slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingPhysical} />
                                }
                                <Form>
                                    <div className="row">
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='text'
                                                label={formatMessage({ id: 'Agenda Title' })}
                                                fieldName='AgendaTitle'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Agenda Title' })}
                                                toolTipText={formatMessage({
                                                    id: 'Add title of this agenda here.',
                                                })}
                                                onBlur={formik.handleBlur}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TagInput
                                                label={formatMessage({ id: 'Presenter (If any)' })}
                                                fieldName='Presenter'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter presenter name' })}
                                                tooltip={formatMessage({
                                                    id: 'Add name of the presenter of the meeting, if any.',
                                                })}
                                                initialOptions={userList}
                                            />
                                        </div>
                                        <div className='col-12'>
                                            <TextArea
                                                label={formatMessage({ id: 'Agenda description' })}
                                                fieldName='Description'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Agenda description' })}
                                                toolTipText={formatMessage({
                                                    id: 'Describe the meeting agenda here for attendees knowledge.',
                                                })}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='text'
                                                label={formatMessage({ id: 'Link (if any)' })}
                                                fieldName='Link'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Link' })}
                                                toolTipText={formatMessage({
                                                    id: 'Add a link to the agenda of the meeting, if any.',
                                                })}
                                                onBlur={formik.handleBlur}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-3 ms-md-0'>
                                                {formatMessage({ id: 'Minutes assigned to this particular agenda' })}{'*'} <ToolTipUIForModal tooltipText={formatMessage({ id: 'Specify the time being allotted to this particular meeting agenda.' })} />
                                            </label>
                                            <Field
                                                as='select'
                                                name='MinuteAssigned'
                                                className='form-select h-40px font-size-13'
                                                onBlur={formik.handleBlur}
                                            >
                                                <option className='text-muted' hidden>
                                                    {formatMessage({ id: 'Enter minutes for this agenda' })}
                                                </option>
                                                {MinutesToAssigned?.map((option: any, index) => {
                                                    return <option key={index} value={option.value} disabled={option.value.split(' ')[0] > (editData ? leftTime + parseInt(editData.assignedTime.split(' ')[0]) : leftTime)}>
                                                        {option.name}
                                                    </option>
                                                })}
                                            </Field>


                                        </div>
                                        <div className="col-md-6 col-12">
                                            <div className='d-flex form-label  text-dark font-size-13'>
                                                {formatMessage({ id: 'Attach files' })}
                                                <ToolTipUIForModal
                                                    tooltipText={formatMessage({
                                                        id: 'Add/upload documents pertaining to this Share Transaction like Share Certificate, Purchase Agreement, etc.',
                                                    })}
                                                />
                                            </div>
                                            <div className='w-100' >
                                                <button className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100' onClick={handleOpen} type="button">
                                                    {formatMessage({ id: 'Import Files' })}
                                                </button>

                                            </div>
                                            <FileUpload
                                                fileSize={parseInt(
                                                    process.env.REACT_APP_STAKEHOLDERS_MAX_FILE_SIZE as string
                                                )}
                                                maxFileNumber={10}
                                                allowType={allowedFileTypes}
                                                metaData={{ module: 'document', isProtected: false }}
                                                modalStatus={modelStatus}
                                                handleClose={handleClose}
                                                handleSuccess={(id: number, name: string) => {
                                                    setFiles((prevFiles: any) => [...prevFiles, { id, name: name.split('/').pop() }])
                                                    const currentFileIds = Array.isArray(formik.values.fileIds)
                                                        ? formik.values.fileIds
                                                        : []
                                                    formik.setFieldValue('fileIds', [...currentFileIds, id])

                                                }}
                                                resourceType='all'
                                            />
                                            <div className='mb-4'>
                                                <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                                    {formatMessage({ id: 'Uploaded Files' })}
                                                    <ToolTipUIForModal
                                                        tooltipText={formatMessage({ id: 'Manage all uploaded documents here.' })}
                                                    />
                                                </div>
                                                <div className='w-100'>
                                                    <ul className='p-0 m-0'>
                                                        {files.map((file: any) => (
                                                            <li
                                                                key={file.id}
                                                                className='d-flex align-items-center justify-content-between gap-2 text-decoration-none mb-2'
                                                            >
                                                                <div className='d-flex'>
                                                                    <img src={getFileType(file.name)} alt='' />
                                                                    <p className='p-0 ms-2'>{file.name}</p>
                                                                </div>
                                                                <button
                                                                    className='btn btn-secondry p-0 m-0'
                                                                    onClick={() => {
                                                                        setShowCancelModal(true)
                                                                        setId(file.id)
                                                                    }}
                                                                    type='button'
                                                                >
                                                                    <img src={deleteIcon} alt='Delete' />
                                                                </button>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            </Modal.Body>
                            <Modal.Footer className="p-0 container">
                                <div className='d-flex my-md-4 mx-6 mx-md-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1 mb-2'>
                                    <button
                                        type='button'
                                        onClick={() => { setIsActive(false) }}
                                        className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                                        style={{ padding: '15px 40px' }}
                                    >
                                        <span className='indicator-label font-size-13 p-0'>
                                            {formatMessage({ id: 'Cancel' })}
                                        </span>
                                    </button>
                                </div>
                                <div className='d-flex my-md-4  mx-6 mx-md-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2 mb-2'>
                                    <button
                                        className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
                                        style={{ padding: '15px 40px' }}
                                        type="button"
                                        disabled={loading || !formik.isValid}
                                        onClick={() => { editData ? handleUpdateSubmit(formik) : handleSubmit(formik.values) }}
                                    >
                                        <span className='indicator-label font-size-13 p-0'>
                                            {loading ? formatMessage({ id: 'Please wait ...' }) : formatMessage({ id: 'Save' })}

                                        </span>
                                    </button>
                                </div>

                            </Modal.Footer>
                        </>)
                }}
            </Formik>
        </Modal >
        <DeleteFileConfirmationModal
            setDeleteShowModal={setShowCancelModal}
            showDeleteModal={showCancelModal}
            onDeleteSubmit={deleteFile}
            deleteLoading={cancelLoading}
        />
    </>
}